import React, { useState, useRef, useEffect } from 'react'
import './code.scss'

const Code = props => {
  const {
    placeholder,
    onChange,
    disabled,
    split,
    value,
    onFocus,
    onKeyUp,
    error,
    resetErrorMessage
  } = props
  const inputs = useRef(new Array(split.length))
  const [getValue, setValue] = useState(formatPostalCode(value))
  function replaceAll (src, search, replace) {
    return src?.split(search).join(replace)
  }

  useEffect(() => {
    if (inputs?.current[0]) {
      inputs.current[0].focus()
    }
  }, [])

  useEffect(() => {
    setValue(formatPostalCode(value))
  }, [value])

  function formatPostalCode (value) {
    value = replaceAll(value.trim(), '-', '')
    const showValue = []
    const splitFunc = (index, num) => {
      if (parseInt(index) < 0) return 0
      if (parseInt(index) === 0) return num

      return num + splitFunc(index - 1, split[index - 1])
    }
    for (let index = 0; index < split.length; index++) {
      const slic = value.slice(
        splitFunc(index - 1, split[index - 1]),
        splitFunc(index, split[index])
      )
      showValue.push(slic)
    }
    return showValue.join('-')
  }

  const handleChange = e => {
    if (resetErrorMessage) resetErrorMessage()
    e.stopPropagation()
    const { value } = e.target
    const index = parseInt(e.target.name)
    const valueLength = getValue?.split('-').join('').length
    const totalSplit = split.reduce((a, b) => a + b, 0)
    if (valueLength <= totalSplit) {
      const statevalue = getValue?.split('-')
      if (value.length <= split[index]) {
        if (!/^\s*\d*\s*$/.test(value)) {
          e.preventDefault()
        } else if (value === '') {
          statevalue[index] = value
        } else {
          statevalue[index] = value
        }
      }

      const formatted = formatPostalCode(statevalue.join(''))

      setValue(formatted)
      onChange(formatted?.split('-').join(''))

      if (e.target.value !== '') {
        if (split[index] === formatted?.split('-')[index].length) {
          if (index < split.length - 1) inputs.current[index + 1].focus()
        }
      }
    }
  }
  const handleOnKeydown = event => {
    // event.stopPropagation();
    // event.preventDefault();
    const index = parseInt(event.target.name)
    const key = event.keyCode || event.charCode
    if (key == 8 || key == 46) {
      if (index > 0) {
        setTimeout(() => {
          inputs.current[index - 1].focus()
        })
      }
    }
  }

  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      if (props.onKeyPress && typeof props.onKeyPress === 'function') {
        props.onKeyPress()
      } else {
        return
      }
    }
  }

  const handlePaste = event => {
    event.stopPropagation()
    event.preventDefault()
    const index = event.target.name
    const clipboardData = event.clipboardData || window.clipboardData
    let pastedData = clipboardData.getData('Text')
    const statevalue = getValue?.split('-')
    for (const i in split) {
      let str = ''
      for (let y = 1; y <= split[i]; y++) {
        const res = pastedData.charAt(0)
        str = str.concat(res)
        pastedData = pastedData.substring(1)
      }
      statevalue[i] = str
    }
    const formatted = formatPostalCode(statevalue.join(''))
    setValue(formatted)
    onChange(formatted?.split('-').join(''))
    inputs.current[split.length - 1].focus()
  }

  return (
    <>
      <div className={`otp__code ${error ? 'input_error' : ''}`}>
        {split.map((item, index) => (
          <label key={index}>
            <input
              onKeyPress={handleKeyPress}
              className='form-input primary-color'
              type='tel'
              name={index}
              placeholder='_'
              ref={ref => (inputs.current[index] = ref)}
              // placeholder={formatPostalCode(placeholder)?.split('-')[index]}
              value={getValue?.split('-')[index]}
              onChange={handleChange}
              onKeyDown={handleOnKeydown}
              onPaste={handlePaste}
              onFocus={onFocus}
              disabled={disabled}
              onKeyUp={onKeyUp}
              data-tracking-id='otp-input'
              style={props.otpError ? { border: '1px solid #DF2040' } : {}}
            />
          </label>
        ))}
      </div>
      {props.otpError && (
        <p id='error-code'>{props.otpError}</p>
      )}
    </>
  )
}

Code.defaultProps = {
  placeholder: '',
  value: ''
}

export default Code
